import { makeRoutes } from 'utils/routes';

const paths = makeRoutes({
  rootPath: () => '/admin/',
  usersPath: () => '/admin/loginUsers',
  clientsPath: () => '/admin/clients',
  reportsPath: () => '/reports',
  clientMbdReportsPath: (clientId: ID) => `/clients/${clientId}/mbdReport`,
  departmentProductivityReportPath: (clientId: ID) => `/clients/${clientId}/mbdReport/department-productivity-report`,
  teamDetailReportPath: (clientId: ID) => `/clients/${clientId}/mbdReport/team-detail-report`,
  personalTeamDetailReportPath: (clientId: ID, memberId: ID) =>
    `/clients/${clientId}/mbdReport/team-detail-report/${memberId}`,
  projectNameDetailReportPath: (clientId: ID) => `/clients/${clientId}/mbdReport/project-name-detail-report`,
  attorneyDetailReportPath: (clientId: ID) => `/clients/${clientId}/mbdReport/attorney-detail-report`,
  attorneyDetailReportUserPath: (clientId: ID, id: ID) => `/clients/${clientId}/mbdReport/attorney-detail-report/${id}`,
  practiceGroupReportPath: (clientId: ID) => `/clients/${clientId}/mbdReport/practice-group-report`,
  practiceGroupDetailReportPath: (clientId: ID, practiceGroupId: ID) =>
    `/clients/${clientId}/mbdReport/practice-group-report/${practiceGroupId}`,
  companyReportPath: (clientId: ID) => `/clients/${clientId}/mbdReport/company-detail-report`,
  companyDetailReportPath: (clientId: ID, id: ID) => `/clients/${clientId}/mbdReport/company-detail-report/${id}`,
  projectTypeReportPath: (clientId: ID) => `/clients/${clientId}/mbdReport/project-type-report`,
  winlossReportPath: (clientId: ID) => `/clients/${clientId}/mbdReport/winloss-report`,
  awardNominationsReportPath: (clientId: ID) => `/clients/${clientId}/mbdReport/award-nominations-report`,
  companyPath: (clientId: ID, companyId: ID) => `/clients/${clientId}/mbdReport/companies/${companyId}`,
  projectPath: (clientId: ID, projectId: ID) => `/clients/${clientId}/mbdReport/projects/${projectId}`,
  clientAttorneyReportsPath: (clientId: ID) => `/clients/${clientId}/attorneyReport`,
  activityReportPath: (clientId: ID) => `/clients/${clientId}/attorneyReport/activity-reports`,
  teamPointsReportPath: (clientId: ID) => `/clients/${clientId}/attorneyReport/team-points-reports`,
  teamPointsByActivityReport: (clientId: ID) => `/clients/${clientId}/attorneyReport/team-points-by-activity-reports`,
  monthlyTotalReportPath: (clientId: ID) => `/clients/${clientId}/attorneyReport/monthly-total-reports`,
});

export default paths;
